import {isNotNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {GetCheckoutPaymentTemplatesApiResponse} from '@dms/api/sales';

import {Nullish} from 'shared/web';

export function resolveCheckoutPaymentTemplateId(
  templates: GetCheckoutPaymentTemplatesApiResponse | undefined,
  currentTemplateId: string | Nullish
): string | undefined {
  const availableTemplates = templates ?? [];

  if (isNotNilOrEmpty(availableTemplates) && isNotNil(currentTemplateId)) {
    const isCurrentTemplateAvailable = availableTemplates.some(
      (template) => template.id === currentTemplateId
    );

    if (!isCurrentTemplateAvailable) {
      return availableTemplates.find((template) => template.isDefault)?.id;
    }
  }

  return currentTemplateId ?? undefined;
}
